import { GetFieldDefBy } from "../utils/GetFieldDefBy";
import { QXMLObject } from "./QXMLObject";

export class QShortcut extends QXMLObject {
  constructor() {
    super();
    this.fShortcutName = null;
    this.fShortcutObjID = null;
    this.fShortcutObj = null;
    this.fShortcutField = null;
  }

  DoInitShortcut() {
    this.SetXMLElementName("shortcut");
  }

  InitShortcut(shortcutName, dbObj) {
    this.fShortcutName = shortcutName;
    this.fShortcutObj = dbObj;
    this.fShortcutObjID = dbObj.GetObjectID();
    this.DoInitShortcut();
  }

  OutputToJSON() {
    var shortCutObj = {};
    shortCutObj["name"] = this.fShortcutName;
    shortCutObj["ObjID"] = this.fShortcutObjID;
    return shortCutObj;
  }

  LoadFromJSON(json) {
    this.fShortcutName = json["name"];
    this.fShortcutObjID = json["ObjID"];
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("sname", this.fShortcutName, stream);
    this.OutputSimpleElement("sobjid", this.fShortcutObjID, stream);
  }

  LoadSubElements(objTree) {
    this.fShortcutName = objTree.GetValueForChild("sname", false);
    this.fShortcutObjID = objTree.GetValueForChild("sobjid", true);
  }

  GetShortcutName() {
    return this.fShortcutName;
  }

  GetDataObj() {
    return this.fShortcutObj;
  }

  GetDataObjID() {
    return this.fShortcutObjID;
  }

  GetShortcutField() {
    if (this.fShortcutField != null) return this.fShortcutField;
    else return "_";
  }

  WireShortcut(theDoc) {
    var objDB = theDoc.GetObjDB();
    var aClass = objDB.GetClassByName("Box");
    var idDef = aClass.GetFieldDefByID("ID");
    var matchObj = aClass.FindObject(idDef, this.fShortcutObjID, true);
    this.fShortcutObj = matchObj;
    return matchObj;
  }
}
